// Titik masuk dashboard. Komponennya sendiri tetap di EARemoteController.jsx
// di root repo — file itu yang dijaga backend/test/dashboard-contract.test.js.
import { createRoot } from "react-dom/client";
import EARemoteController from "../EARemoteController.jsx";
import LandingPage from "./LandingPage.jsx";

// Query string sengaja dipakai alih-alih router: dua halaman, nol dependency,
// dan direct-link tetap bekerja saat hasil build disajikan sebagai file statis.
const dashboard = new URLSearchParams(window.location.search).has("app");
document.title = dashboard ? "Dashboard — Smart Remote EA Assistant" : "Smart Remote EA Assistant — MT5 Trading Companion";

createRoot(document.getElementById("root")).render(
  dashboard ? <EARemoteController /> : <LandingPage />,
);
